export const setOpenLoaderTrue = () => ({
  type: "OPEN_LOADER",
});

export const setOpenLoaderFalse = () => ({
  type: "CLOSE_LOADER",
});
